import { render } from "./ca-header.vue?vue&type=template&id=1fe41ed0&ts=true"
import script from "./ca-header.vue?vue&type=script&lang=ts"
export * from "./ca-header.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__